import {
  Checkbox,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  FormGroup,
  Typography,
} from "@mui/material";
import { Button, ButtonGroup, Card } from "@mui/material";
import Box from "@mui/material/Box";
import { useQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { executeBatchCreateSchedule } from "../../api/batch";
import { getDepartmentSchedules } from "../../api/department_schedule";
import { useCalendar } from "../../hooks/useCalendar";
import CommonCalendar from "./CommonCalendar";
import { OnDutyRequestMemoList } from "./OnDutyRequestMemoList";
import ScheduleEditByCreateSchedule from "./ScheduleEditByCreateSchedule";

export default function CalendarByCreateSchedule() {
  const [openConfirmCreateSchedule, setOpenConfirmCreateSchedule] =
    useState(false);
  const [ignoreConfirmation, setIgnoreConfirmation] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const {
    pivot,
    setSchedules,
    open,
    scheduleData,
    scheduleDate,
    scheduleByDate,
    scheduleMap,
    handleClickOpen,
    handleClose,
    handleThisMonth,
    handleNextMonth,
    handlePrevMonth,
    canAllDay,
    checkRegister,
  } = useCalendar();

  const { data: schedules, isSuccess: isSuccessSchedules } = useQuery({
    queryKey: ["scheduleByType", pivot],
    queryFn: () =>
      getDepartmentSchedules(
        pivot.format("YYYY"),
        pivot.format("MM"),
        [1, 7], // schedule_typesテーブルの、当直+オンコールのIDを指定
      ),
    throwOnError: true,
    enabled: true,
  });

  useEffect(() => {
    if (isSuccessSchedules) {
      setSchedules(schedules);
    }
  }, [isSuccessSchedules, schedules, setSchedules]);

  const renderScheduleTypeSelector = () => (
    <Box>
      <Typography>
        当直・オンコールのスケジュールのみ表示されています
      </Typography>
    </Box>
  );

  const cellStyles = {
    borderLeft: 1,
    borderTop: 1,
    borderColor: "#999",
    width: "100%",
    paddingTop: "4px",
    paddingBottom: "4px",
  };

  const handleExecuteBatchCreateSchedule = async () => {
    setOpenConfirmCreateSchedule(false);
    setIsLoading(true);
    const form = new FormData();
    form.append("department_id", 1);
    form.append("year", pivot.format("YYYY"));
    form.append("month", pivot.format("MM"));
    form.append("ignore_confirmation", ignoreConfirmation);
    await executeBatchCreateSchedule(form);
    setIsLoading(false);
  };

  return (
    <>
      <Box display="flex" flexDirection="column" gap={2}>
        <Box display="flex" justifyContent="flex-end" alignItems="center">
          {isLoading && (
            <CircularProgress
              color="secondary"
              size={30}
              sx={{ marginRight: 1 }}
            />
          )}
          <ButtonGroup>
            {/* TODO: 確定ボタン処理 */}
            <Button
              onClick={() => {
                alert("未実装です🙇‍♂️");
              }}
            >
              確定
            </Button>
            <Button onClick={() => setOpenConfirmCreateSchedule(true)}>
              スケジュール作成
            </Button>
          </ButtonGroup>
        </Box>

        <ScheduleEditByCreateSchedule
          key={Date.now()}
          isNew={scheduleData === null}
          date={scheduleDate}
          obj={scheduleData}
          byDate={scheduleByDate}
          open={open}
          onClose={handleClose}
          canAllDay={canAllDay}
          checkRegister={checkRegister}
          paramScheduleTypeId={scheduleData?.schedule_type_id ?? 0}
        />

        <Card
          sx={{
            borderRadius: "4px",
          }}
        >
          <CommonCalendar
            pivot={pivot}
            handleThisMonth={handleThisMonth}
            handlePrevMonth={handlePrevMonth}
            handleNextMonth={handleNextMonth}
            scheduleMap={scheduleMap}
            handleClickOpen={handleClickOpen}
            cellStyles={cellStyles}
            renderScheduleTypeSelector={renderScheduleTypeSelector}
          />
          <Box sx={{ marginTop: "15px" }}>
            <OnDutyRequestMemoList pivot={pivot} />
          </Box>
        </Card>
      </Box>

      <FormGroup>
        <Dialog
          open={openConfirmCreateSchedule}
          onClose={(_, reason) => {
            if (
              reason &&
              (reason === "backdropClick" || reason === "escapeKeyDown")
            )
              return;
            setOpenConfirmCreateSchedule(false);
          }}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            当直・オンコール自動割当処理を実行しますか？
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <FormControlLabel
                control={<Checkbox defaultChecked />}
                label="確定済か否かに関わらず強制的に割当を行う"
                checked={ignoreConfirmation}
                onChange={(e) => setIgnoreConfirmation(e.target.checked)}
              />
            </DialogContentText>
            <DialogContentText>
              チェックを入れない場合、全医師が予定を確定済にする必要があります
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenConfirmCreateSchedule(false)}>
              キャンセル
            </Button>
            <Button
              onClick={() => {
                handleExecuteBatchCreateSchedule();
              }}
              autoFocus
              variant="contained"
              color="error"
            >
              実行
            </Button>
          </DialogActions>
        </Dialog>
      </FormGroup>
    </>
  );
}
